import React from 'react'
import { Link, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { selectRole } from '../../../routing/fetchingfunction/user/user.reducer'

import { getTradingTabs } from '../../../constants'

const Trading = () => {
  const role = useSelector(selectRole)

  const location = useLocation()

  const tradingTabsContent = getTradingTabs(role).map((tab, index, array) => {
    const isActive = tab.exact
      ? location.pathname === tab.href
      : location.pathname.includes(tab.href)

    return (
      <Link
        key={tab.href}
        to={tab.href}
        className={`py-[6px] px-[10px] text-xs text-white leading-[18px] transition-colors duration-200 ease ${isActive ? 'bg-[#F9FAFB] !text-primary-100 font-semibold' : 'font-normal'} ${index === 0 ? 'rounded-l-[4px]' : ''} ${index === array.length - 1 ? 'rounded-r-[4px]' : 'border-r-white border-r-[1px]'}`}
      >
        {tab.label}
      </Link>
    )
  })

  return (
    <div className="w-full flex flex-col items-start relative">
      <div
        className="absolute -top-12 right-0 w-fit flex items-center justify-end mb-[16px] border-white border-[1px] rounded-[4px] shadow-button"
        role="group"
      >
        {tradingTabsContent}
      </div>
      <Outlet />
    </div>
  )
}

export default Trading
